<div class="error-popup-page-container">
  {{ errorMessage }}
</div>